import { render, staticRenderFns } from "./base-comparaison-bar-chart.vue?vue&type=template&id=4b3de665"
import script from "./base-comparaison-bar-chart.vue?vue&type=script&lang=js"
export * from "./base-comparaison-bar-chart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports